import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import BottomNav from './BottomNav';
import { ConfirmDialog } from '../ui';

export default function MainLayout() {
  return (
    <div className="min-h-screen bg-neutral-light">
      <Sidebar />
      <div className="main-content pb-20 lg:pb-0">
        <Header />
        <main className="p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
      <BottomNav />
      <ConfirmDialog />
    </div>
  );
}
